module.exports = {
      id: "arrow-down-usage",
      viewBox: "0 0 22.422 26.468",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#arrow-down",
      toString: function () {
        return this.url;
      }
    }